// extracted by mini-css-extract-plugin
module.exports = {"showMoreButton":"clinical-portal-3__ShowMoreSectionButton__showMoreButton"};